<template>
  <div class="container-md plr-0">
    <div class="container-bg p-4">
      <h3>Actieve Leden: {{ activeMembers }}</h3>
      <div class="row">
        <div class=" col-md-9 col-12">
          <div class="float-right mem-srch-wrap">
            <input
              class="search-box"
              type="text"
              v-model="query"
              placeholder="Zoeken"
            />
            <button class="search-btn">
              <img
                src="/assets/img/search.svg"
                alt="Search"
                style="margin-bottom: 4px"
              />
            </button>
          </div>
        </div>
        <!-- <div class="col-md-2 col-6 float-md-left float-right">
            <button class="btn btn-dark ml-3">Export</button>
        </div> -->
        <div
          v-if="userHasRoles(['Ledenadministratie']) == true"
          class=" col-md-1 col-6 float-md-left float-left"
        >
          <a href="/profile/create" class="text-black">
            <i
              class="fa fa-plus"
              style="line-height: inherit; font-size: 32px; cursor: pointer"
            ></i>
          </a>
        </div>
      </div>

      <table class="table table-responsive">
        <thead>
          <tr class="text-black text-uppercase">
            <th></th>
            <th>Lid</th>
            <th>Commissies</th>
            <th>Groepen</th>
            <th>Taken</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="flex-body mb-4"
            v-for="member in filterMembers"
            :key="'member_' + member.id"
            :class="{ 'bg-dark': member.active }"
          >
            <td width="10%">
              <img
                class="img-fluid img-thumbnail"
                :src="
                  member.profile_image
                    ? member.profile_image
                    : '/assets/icon.jpg'
                "
                style="
              border: 1px solid #ffffff;
              background-color: #fff;
              width: 100%;
            "
              />
            </td>
            <td class="align-middle">
              <span class="text-white" v-if="member.display_name">
                {{ member.display_name }}
              </span>
              <span class="text-white" v-else>
                {{ member.firstname }} {{ member.lastname }}
              </span>
            </td>

            <td class="align-middle">
              <ul>
                <li
                  v-for="committee in member.active_committees"
                  :key="'user_com_' + committee.id"
                >
                  {{ committee.title }}
                </li>
              </ul>
            </td>
            <td class="align-middle">
              <ul>
                <li
                  v-for="group in member.active_groups"
                  :key="'user_group_' + group.id"
                >
                  {{ group.title }}
                </li>
              </ul>
            </td>

            <td class="align-middle">
              <ul>
                <li
                  v-for="task in member.tasks_data"
                  :key="'user_task_' + task.id"
                >
                  {{ task.title }}
                </li>
              </ul>
            </td>

            <td class="align-middle border-tr">
              <div>
                <a
                  v-if="
                    !userHasPermissions(['Ledenadministratie']) &&
                      $store.state.auth.user.id != member.id
                  "
                  :href="'/profile/' + member.id + '/public-view'"
                  class="text-white"
                  style="margin-right: 10px"
                  ><i class="fa fa-eye"></i
                ></a>

                <a
                  v-else
                  :href="'/profile/' + member.id + '/view'"
                  class="text-white"
                  style="margin-right: 10px"
                  ><i class="fa fa-eye"></i
                ></a>

                <a
                  v-if="canEdit(member.id) == true"
                  :href="'/profile/' + member.id + '/edit'"
                  class="text-white"
                  ><i class="fas fa-pencil-alt"></i
                ></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div class="flex-container d-lg-flex d-md-none mem-titl-wrap">
        <div class="item text-uppercase">Lid</div>
        <div class="item text-uppercase">Commissies</div>
        <div class="item text-uppercase">Groepen</div>
        <div class="item text-uppercase">Taken</div>
      </div>
      <div
        class="flex-container flex-body mt-3"
        v-for="member in filterMembers"
        :key="'member_' + member.id"
        :class="{ 'bg-dark': member.active }"
      >
        <div class="item text-center">
          <img
            class="img-fluid img-thumbnail"
            :src="
              member.profile_image ? member.profile_image : '/assets/icon.jpg'
            "
            style="
              border: 1px solid #ffffff;
              background-color: #fff;
              width: 30%;
            "
          />
        </div>
        <div class="item text-white" v-if="member.display_name">
          {{ member.display_name }}
        </div>
        <div class="item text-white" v-else>
          {{ member.firstname }} {{ member.lastname }}
        </div>
        <div class="item text-white">{{ member.names_committees }}</div>

        <div class="item text-white">{{ member.names_responsibilities }}</div>
        <div class="item text-white mem-btn-wrap">
          <div>
            <a
              v-if="
                !userHasPermissions(['Ledenadministratie']) &&
                  $store.state.auth.user.id != member.id
              "
              :href="'/profile/' + member.id + '/public-view'"
              class="text-white"
              style="margin-right: 10px"
              ><i class="fa fa-eye"></i
            ></a>

            <a
              v-else
              :href="'/profile/' + member.id + '/view'"
              class="text-white"
              style="margin-right: 10px"
              ><i class="fa fa-eye"></i
            ></a>

            <a
              v-if="canEdit(member.id) == true"
              :href="'/profile/' + member.id + '/edit'"
              class="text-white"
              ><i class="fas fa-pencil-alt"></i
            ></a>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "members",
  data() {
    return {
      members: [],
      query: "",
    };
  },
  computed: {
    activeMembers: function() {
      if (this.members.length > 0) {
        // eslint-disable-next-line no-unused-vars
        return this.members.filter((member) => {
          // console.log(member);
          // if(member.member_end === null){
          //     return false;
          // }
          //
          // if(Date.parse(member.member_end)-Date.parse(new Date()) <0){
          //     return false;
          // }
          // console.log(member);
          return true;
        }).length;
      }
      return 0;
    },
    filterMembers: function() {
      if (this.members.length > 0 && this.query) {
        return this.members.filter((member) => {
          if (!member) {
            return false;
          }
          if (!member.display_name) {
            return false;
          }
          if (member.display_name && member.firstname && member.lastname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.firstname.toLowerCase().match(this.query.toLowerCase()) ||
              member.lastname.toLowerCase().match(this.query.toLowerCase())
            );
          } else if (member.display_name && member.firstname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.firstname.toLowerCase().match(this.query.toLowerCase())
            );
          } else if (member.display_name && member.lastname) {
            return (
              member.display_name
                .toLowerCase()
                .match(this.query.toLowerCase()) ||
              member.lastname.toLowerCase().match(this.query.toLowerCase())
            );
          } else {
            return member.display_name
              .toLowerCase()
              .match(this.query.toLowerCase());
          }
        });
      } else if (this.members.length > 0) {
        return this.members;
      } else {
        return [];
      }
    },
  },
  created() {
    this.$store.dispatch("get", "/api/v1/active/users").then((data) => {
      this.members = data.data.data;
    });
  },
  methods: {
    canEdit(id) {
      if (this.userHasPermissions(["Ledenadministratie"])) return true;

      if (
        this.$store.state.auth.user.id == id &&
        process.env.VUE_APP_USER_CAN_EDIT_OWN_PROFILE == 1
      )
        return true;

      return false;
    },
  },
};
</script>

<style scoped>
.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
  padding: 10px 16px;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -41px;
  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  /* background: #4192d9 0% 0% no-repeat padding-box; */
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 20px 0;
  width: auto;
}

.table {
  border-collapse: separate;
  border-spacing: 0 15px;
}

td:first-child,
th:first-child {
  border-radius: 10px 0 0 10px;
}
td:last-child,
th:last-child {
  border-radius: 0 20px 20px 0;
}
table td {
  background-color: #4192d9 !important;
  color: white;
}
</style>
